export const Constant = {
    PROJECT_NAME : "gotosam",
    PROJECT_TAG_LINE : "Keep your personal things here",
    PRICE : "₹"
};

export const PSLA_INPUT_TYPE = [
    { _id: 'Text', name: 'Text'},
    { _id: 'Number', name: 'Number'},
];

export const CITY_SELECTION_TYPE = [
    { _id: 'Single City', name: 'Single City'},
    { _id: 'Multiple Cities', name: 'Multiple Cities'},
    { _id: 'All Cities', name: 'All Cities'},
];

export const CD_TYPE_SELECTION = [
    { _id: 'Phone Number', name: 'Phone Number'},
    { _id: 'Email Address', name: 'Email Address'},
    { _id: 'Hyperlink', name: 'Text with Hyperlink'},
    { _id: 'Text', name: 'Text Only'},
];

export const PSLA_REQUIRED_SELECTION = [
    { _id: 'Yes', name: 'Yes'},
    { _id: 'No', name: 'No'}
];


export const getSortOrder = (sortBy, field) => {
  if (!sortBy) return null;

  const [sortField, sortDirection] = sortBy.split(":");
  if (sortField !== field) return null;

  return sortDirection === "asc" ? "ascend" : "descend";
};
